
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-ja",
      function () {
        return require("private-next-pages/terms-ja.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-ja"])
      });
    }
  